import type { RoleDetail, RoleListItem } from '~/types/roles';
import { pbRequest } from '~/services/request';

// Company roles and their permission detail.
export const rolesService = {
    /**
     * Get all available roles for a company
     */
    async getRoles(companyId: number): Promise<RoleListItem[]> {
        return await pbRequest<RoleListItem[]>(`/companies/${companyId}/roles`, {
            failure: 'Failed to fetch roles',
        });
    },

    async getRole(companyId: number, roleName: string, guard?: string): Promise<RoleDetail> {
        // Pass the guard so the backend can disambiguate same-named roles across
        // guards (business vs privacy_bee) on the Privacy Bee company (Codex).
        const query = guard ? `?guard=${encodeURIComponent(guard)}` : '';
        return await pbRequest<RoleDetail>(`/companies/${companyId}/roles/${encodeURIComponent(roleName)}${query}`, {
            failure: 'Failed to fetch role',
        });
    },
};
